var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tlive-livetype__contanier" },
    _vm._l(_vm.liveType, function (item) {
      return _c(
        "div",
        {
          key: item.type,
          staticClass: "tlive-livetype--item",
          class: { "is-active": item.type === _vm.value },
          on: {
            click: function ($event) {
              return _vm.setLiveType(item.type)
            },
          },
        },
        [
          _c("yxt-svg", {
            attrs: {
              width: "24px",
              height: "24px",
              "remote-url": _vm.remoteUrl,
              "icon-class": item.svgName,
            },
          }),
          _c("span", [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]),
          item.type === _vm.value
            ? _c("yxt-svg", {
                staticClass: "tlive-livetype--tick",
                attrs: {
                  width: "14px",
                  height: "14px",
                  "remote-url": _vm.remoteUrl,
                  "icon-class": "tick",
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }